import { type location } from 'core/types'
import { LocationDetails } from 'Components/Cards/LocationCard/LocationDetails'
import { MapStateName } from 'Components/Cards/LocationCard/mapStateName'

export interface LocationSelectEditProps {
  location: location
  onEnter: (newValue: location) => void
  hidePrimary?: boolean
  showHomelessOption: boolean
  hideStreet?: boolean
  errors?: string[]
}

export function LocationSelect (props: LocationSelectEditProps): JSX.Element {
  const handleBlur = (newData: location): void => {
    props.onEnter(newData)
  }

  const handleEditChange = (e: any): void => {
    const newData = { ...props.location, [e.target.name]: e.target.value }
    props.onEnter(newData)
  }

  const handlePlaceSelected = async (place: Microsoft.Maps.ISuggestionResult): Promise<void> => {
    const newplace: location = { ...props.location }
    newplace.address = place.address.addressLine
    newplace.city = place.address.locality
    newplace.apartment = ''
    newplace.state = MapStateName(place.address.adminDistrict)
    newplace.zipCode = place.address.postalCode

    props.onEnter(newplace)
  }

  return <LocationDetails
    hidePrimary={props.hidePrimary}
    showHomelessOption={props.showHomelessOption}
    hideStreet={props.hideStreet}
    editData={props.location}
    childID={null}
    onBlur={handleBlur}
    onChange={handleEditChange}
    onPlaceSelected={handlePlaceSelected}
    errors={props.errors}
  />
}
